import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import useSWR from 'swr';
import { fetcher } from '../../../services/api';
import Pagination from 'rsuite/Pagination';
import MyLoader from '../../common/loader.component';
import { CleanCompositeDelivery } from '../../../export-types/cleaned-types';
import { OutletContextParams } from './composite-deliveries-screen';
import { usePaginationQs } from '../../../utils/usePagination';
import { useSearchParamsPaginationEffect } from '../purchase-order/useSearchParamsPaginationEffect';
import { CompositeDeliveryTabItem } from './composite-delivery-tab-item';

type CompositeDeliveryTabProps = {
  status: string;
};

export const CompositeDeliveriesTab = ({
  status,
}: CompositeDeliveryTabProps) => {
  const navigate = useNavigate();
  const { take, skip, handleSetPage, handleChangeLimit, page } =
    usePaginationQs(15);
  useSearchParamsPaginationEffect(handleSetPage);

  const { debouncedInternalId, selectSupplierId } =
    useOutletContext<OutletContextParams>();

  const { data, error, isLoading } = useSWR<{
    total: number;
    items: Array<CleanCompositeDelivery>;
  }>(
    () => ({
      url: '/composite-delivery',
      params: {
        status: [status],
        ...(debouncedInternalId
          ? {
              internalId: debouncedInternalId,
              supplierId: selectSupplierId,
              skip: 0,
            }
          : { take, skip }),
      },
    }),
    fetcher,
  );

  const onRowClick = (rowData: { id: string }) => {
    navigate(`/composite-deliveries/${rowData.id}`);
  };

  const onDeliveryRowClick = (rowData: { id: string }) => {
    navigate(`/deliveries/delivery-order/${rowData.id}`);
  };

  if (isLoading) {
    return (
      <>
        <div className="pb-4">
          <MyLoader />
        </div>
      </>
    );
  }

  if (error || !data) {
    return (
      <>
        <div className="pb-4">Неизвестная ошибка</div>
      </>
    );
  }

  return (
    <>
      <div className="pb-4">
        {data.items.map((data) => (
          <CompositeDeliveryTabItem
            key={data.id}
            data={data}
            onDeliveryRowClick={onDeliveryRowClick}
            onClick={onRowClick}
            status={status}
          />
        ))}
      </div>
      {data.total > take && (
        <Pagination
          className="pb-4"
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={['pager']}
          total={data.total}
          limit={take}
          activePage={page}
          onChangePage={handleSetPage}
          onChangeLimit={handleChangeLimit}
        />
      )}
    </>
  );
};
